import DiscoverMain from "../components/DiscoverMain";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Discovery(){
    return(
        <>
            <Header/>
            <DiscoverMain></DiscoverMain>
            <Footer></Footer>
        </>
    );
}

export default Discovery;